<template>
  <v-container>
    <!-- <v-container fluid class="pa-0 ma-0">
      <v-img max-height="25vh" :src="event.header" />
    </v-container> -->
    <v-container class="pa-6 pt-10" fluid>
      <v-row>
        <v-col cols="12" class="col-md-6">
          <h1>{{ $t("Calendar") }}</h1>
        </v-col>
        <v-col cols="12" class="col-md-6 text-right">
          <p class="pl-4 ma-0">{{ event.name }}</p>
          <p class="pl-4 ma-0">{{ event.dates }}</p>
        </v-col>
        <v-col cols="12" class="text-right">
          <router-link :to="`/calendar/add/`">
            <v-btn> {{ $t("Add Event") }}</v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="services-list">
      <v-row dense>
        <v-col class="col-sm-12 col-md-12">
          <v-card class="pa-0" flat>
            <v-card-title >
              <v-container class="text-center">
                <v-btn icon class="ma-2" @click="prev">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                {{ title }}
                <v-btn icon class="ma-2" @click="next">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-sheet tile height="54" class="d-flex">
                <v-select
                  v-model="calendarType"
                  :items="types"
                  dense
                  outlined
                  hide-details
                  class="ma-2"
                  label="type"
                ></v-select>
                <v-select
                  v-model="gamesType"
                  v-on:change="changeRoute"
                  :items="gametypes"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  hide-details
                  class="ma-2"
                  label="Games"
                ></v-select>
              </v-sheet>
              <v-sheet height="1000">
                <v-calendar
                  ref="calendarRef"
                  :type="calendarType"
                  v-model="calendarStart"
                  :events="this.calendar"
                  event-overlap-mode="column"
                  @click:event="showEvent"
                  @moved="moved"
                ></v-calendar>
                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  offset-x
                >
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                    class="calendar-description"
                  >
                    <v-toolbar :color="selectedEvent.color" dark>
                      <v-toolbar-title
                        v-html="selectedEvent.name"
                      ></v-toolbar-title>
                      <v-spacer></v-spacer>
                      <router-link
                        :to="`/calendar/edit/${selectedEvent.calendarID}`"
                      >
                        <v-btn icon>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </router-link>
                    </v-toolbar>
                    <v-card-text>
                      <h3>{{ $t("Start") }}: {{ selectedEvent.start }}</h3>
                      <h3>{{ $t("End") }}: {{ selectedEvent.end }}</h3>
                      <editor
                        :data="selectedEvent.description"
                        :readOnly="true"
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);
import editor from "../../components/editorCalendar.vue";

import { format } from "date-fns-tz";

export default {
  name: "Calendar",
  route: {
    path: "/calendar/:eventid?",
    name: "Calendar",
  },
  data: () => ({
    event: {
      name: "",
      dates: "",
      header: "",
    },
    calendar: [],
    calendarType: "month",
    types: ["month", "week", "day"],
    calendarStart: new Date(),
    selectedEvent: {
      gamesID: "",
    },
    gametypes: [
      { name: "All Events", id: "" },
      { name: "No Games", id: "none" },
    ],
    gamesType: "",
    title: "",
    selectedElement: null,
    selectedOpen: false,
  }),
  components: {
    editor,
  },
  beforeMount() {
    this.getEvents();
  },

  methods: {
    changeRoute(val) {
      this.$router.push(`/calendar/${val}`);
      this.calendar = [];
      this.getEvents();
    },
    async getEvents() {
      let snapshot = await db.collection("events").get();
      this.events = snapshot.docs.map((doc) => {
        this.gametypes.push({
          name: doc.data().name,
          id: doc.id,
        });
      });
      if (
        typeof this.$route.params.eventid !== "undefined" &&
        this.$route.params.eventid != "none"
      ) {
        db.collection("calendar")
          .where("gamesID", "==", this.$route.params.eventid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().hidden == false) {
                let data = doc.data();
                (data.start = format(new Date(data.start), "yyyy-MM-dd HH:mm")),
                  (data.end = format(new Date(data.end), "yyyy-MM-dd HH:mm")),
                  this.calendar.push(data);
              }
            });
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      } else if (this.$route.params.eventid == "none") {
        db.collection("calendar")
          .where("gamesID", "==", "")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().hidden == false) {
                let data = doc.data();
                (data.start = format(new Date(data.start), "yyyy-MM-dd HH:mm")),
                  (data.end = format(new Date(data.end), "yyyy-MM-dd HH:mm")),
                  this.calendar.push(data);
              }
            });
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      } else {
        let snapshot = await db.collection("calendar").get();
        snapshot.docs.map((doc) => {
          if (doc.data().hidden == false) {
            let data = doc.data();
            (data.start = format(new Date(data.start), "yyyy-MM-dd HH:mm")),
              (data.end = format(new Date(data.end), "yyyy-MM-dd HH:mm")),
              this.calendar.push(data);
          }
        });
      }
    },
    prev() {
      this.$refs.calendarRef.prev();
    },
    next() {
      this.$refs.calendarRef.next();
    },
    moved() {
      setTimeout(() => {
        this.title = this.$refs.calendarRef.title;
      }, 50);
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
  },
  mounted: function () {
    console.log(this.$router.getMatchedComponents()[0]);
    this.title = this.$refs.calendarRef.title;
  },
};
</script>

<style lang="scss">
a {
  text-decoration-line: none;
}

.calendar-description {
  .codex-editor {
    max-width: 300px;
    height: 300px;
    max-height: 300px;
    overflow: scroll;

    img: {
      max-width: 300px;
    }
    .codex-editor__redactor {
      padding-bottom: 0 !important;
    }
  }
}
</style>
